import { AxiosConfigExplore } from "Explore/Config/AxiosConfig";

export const getInstitutionOverview = async (institutionId, sections = "all") => {
  const axios = AxiosConfigExplore();
  const res = await axios.get(`/institution/overview?institution_id=${institutionId}&sections=${sections}`);
  return res.data;
};

export const getInstitutionSocialImpact = async (institutionId) => {
  const axios = AxiosConfigExplore();
  const res = await axios.get("/benchmarking/institution/social_impact", {
    params: { entity_id: institutionId },
  });
  return res.data;
};

export const getInstitutionSocialImpactDetail = async (institutionId, sdgNum) => {
  const axios = AxiosConfigExplore();
  const res = await axios.get(`/benchmarking/institution/social_impact/${sdgNum}`, {
    params: { entity_id: institutionId },
  });
  return res.data;
};

